module.exports = __webpack_public_path__ + "img/symbol_good.77675b3b.png";